import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

export default function Projects() {
  return (
    <>
      <Header />
      <h1>ЗДЕСЬ БУДУТ ПРОЕКТЫ</h1>
      <Footer />
    </>
  );
}
